// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.change-prompt-modal {
  /* Glassmorphism effect */
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 1rem;
  padding: 0;
  max-width: 550px;
  width: 90%;
  max-height: 80vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
}

.change-prompt-modal .modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem 2rem;
  border-bottom: 1px solid var(--color-border);
}

.change-prompt-modal .modal-header h2 {
  color: var(--color-text-primary);
  margin: 0;
  font-size: 1.5rem;
}

.change-prompt-modal .close-button {
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  color: var(--color-text-secondary);
  padding: 0;
  line-height: 1;
}

.change-prompt-modal .close-button:hover {
  color: var(--color-text-primary);
}

.change-prompt-modal .modal-body {
  padding: 1.5rem 2rem;
  overflow-y: auto;
  flex: 1 1;
}

.change-prompt-modal .form-group {
  margin-bottom: 1.5rem;
}

.change-prompt-modal .form-group label {
  display: block;
  font-weight: 500;
  color: var(--color-text-primary);
  margin-bottom: 0.5rem;
  font-size: 0.95rem;
}

/* Searchable Dropdown */
.change-prompt-modal .searchable-dropdown {
  position: relative;
  width: 100%;
}

.change-prompt-modal .prompt-search-input {
  width: 100%;
  padding: 0.75rem;
  border: 1px solid var(--color-border);
  border-radius: 0.5rem;
  font-size: 0.95rem;
  background: var(--color-input-bg);
  color: var(--color-text-primary);
  box-sizing: border-box;
}

.change-prompt-modal .prompt-search-input:focus {
  outline: none;
  border-color: var(--color-input-focus);
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.change-prompt-modal .prompt-search-input::placeholder {
  color: var(--color-text-secondary);
}

.change-prompt-modal .prompt-dropdown-list {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  max-height: 200px;
  overflow-y: auto;
  background: var(--color-card-bg);
  border: 1px solid var(--color-border);
  border-top: none;
  border-radius: 0 0 0.5rem 0.5rem;
  z-index: 10;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.change-prompt-modal .dropdown-item {
  padding: 0.75rem;
  cursor: pointer;
  color: var(--color-text-primary);
  font-size: 0.9rem;
  line-height: 1.4;
  border-bottom: 1px solid var(--color-border);
}

.change-prompt-modal .dropdown-item:last-child {
  border-bottom: none;
}

.change-prompt-modal .dropdown-item:hover {
  background: rgba(59, 130, 246, 0.1);
}

.change-prompt-modal .dropdown-item.selected {
  background: rgba(59, 130, 246, 0.15);
  font-weight: 500;
}

.change-prompt-modal .dropdown-no-results {
  padding: 0.75rem;
  color: var(--color-text-secondary);
  font-style: italic;
  text-align: center;
}

/* AI Section */
.change-prompt-modal .ai-section {
  margin-top: 1.5rem;
  padding-top: 1.5rem;
  border-top: 1px solid var(--color-border);
}

.change-prompt-modal .ai-section-header {
  color: var(--color-text-primary);
  font-size: 1.1rem;
  margin: 0 0 1rem 0;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.change-prompt-modal .ai-section-header::before {
  content: '✨';
}

.change-prompt-modal .ai-loading {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  color: var(--color-text-secondary);
  padding: 0.5rem 0;
}

.change-prompt-modal .spinner {
  width: 1.25rem;
  height: 1.25rem;
  border: 2px solid var(--color-border);
  border-top-color: var(--color-primary);
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

.change-prompt-modal .ai-error {
  color: var(--color-danger);
  padding: 0.75rem;
  background: rgba(255, 59, 48, 0.1);
  border-radius: 0.5rem;
  font-size: 0.9rem;
}

.change-prompt-modal .ai-no-suggestions {
  color: var(--color-text-secondary);
  font-style: italic;
  padding: 0.75rem;
}

/* Suggestions List */
.change-prompt-modal .suggestions-list {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.change-prompt-modal .suggestion-item {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  padding: 0.5rem 0;
  cursor: pointer;
}

.change-prompt-modal .suggestion-item:hover {
  opacity: 0.8;
}

.change-prompt-modal .suggestion-item input[type="radio"] {
  margin-top: 0.25rem;
  cursor: pointer;
  accent-color: var(--color-primary);
}

.change-prompt-modal .suggestion-text {
  flex: 1 1;
  color: var(--color-text-primary);
  font-size: 0.9rem;
  line-height: 1.4;
}

.change-prompt-modal .best-match-badge {
  background: var(--color-primary);
  color: white;
  font-size: 0.7rem;
  padding: 0.2rem 0.5rem;
  border-radius: 9999px;
  font-weight: 600;
  white-space: nowrap;
}

/* New Prompt Section */
.change-prompt-modal .new-prompt-section {
  margin-top: 1.25rem;
  padding-top: 1.25rem;
  border-top: 1px dashed var(--color-border);
}

.change-prompt-modal .new-prompt-header {
  color: var(--color-text-primary);
  font-size: 0.95rem;
  margin: 0 0 0.75rem 0;
  font-weight: 500;
}

.change-prompt-modal .new-suggestion {
  border: 1px dashed var(--color-primary);
  background: rgba(59, 130, 246, 0.05);
  padding: 0.75rem;
  border-radius: 0.5rem;
}

.change-prompt-modal .new-prompt-badge {
  background: #10b981;
  color: white;
  font-size: 0.7rem;
  padding: 0.2rem 0.5rem;
  border-radius: 9999px;
  font-weight: 600;
  white-space: nowrap;
}

/* Generate Prompt Button */
.change-prompt-modal .generate-prompt-action {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.change-prompt-modal .btn-generate-prompt {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  background: linear-gradient(135deg, #8b5cf6, #6366f1);
  color: white;
  padding: 0.75rem 1.25rem;
  border: none;
  border-radius: 0.5rem;
  cursor: pointer;
  font-size: 0.95rem;
  font-weight: 500;
  transition: all 0.2s;
  width: 100%;
}

.change-prompt-modal .btn-generate-prompt:hover:not(:disabled) {
  background: linear-gradient(135deg, #7c3aed, #4f46e5);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(139, 92, 246, 0.3);
}

.change-prompt-modal .btn-generate-prompt:disabled {
  opacity: 0.7;
  cursor: not-allowed;
  transform: none;
}

.change-prompt-modal .btn-generate-prompt .spinner {
  width: 1rem;
  height: 1rem;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top-color: white;
}

.change-prompt-modal .generate-prompt-hint {
  color: var(--color-text-secondary);
  font-size: 0.8rem;
  margin: 0;
  text-align: center;
}

/* Modal Actions */
.change-prompt-modal .modal-actions {
  display: flex;
  gap: 1rem;
  justify-content: flex-end;
  padding: 1.5rem 2rem;
  border-top: 1px solid rgba(255, 255, 255, 0.3);
  background: rgba(255, 255, 255, 0.5);
}

.change-prompt-modal .btn-cancel {
  background: var(--color-secondary);
  color: var(--color-text-primary);
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 0.5rem;
  cursor: pointer;
  font-size: 1rem;
  transition: all 0.2s;
}

.change-prompt-modal .btn-cancel:hover:not(:disabled) {
  background: var(--color-secondary-hover);
  transform: translateY(-2px);
}

.change-prompt-modal .btn-cancel:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.change-prompt-modal .btn-accept {
  background: var(--color-primary);
  color: white;
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 0.5rem;
  cursor: pointer;
  font-size: 1rem;
  font-weight: 600;
  transition: all 0.2s;
}

.change-prompt-modal .btn-accept:hover:not(:disabled) {
  background: var(--color-primary-hover, #2563eb);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);
}

.change-prompt-modal .btn-accept:disabled {
  background: var(--color-text-secondary);
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}
`, "",{"version":3,"sources":["webpack://./src/components/ChangePromptModal.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,oCAAoC;EACpC,2BAA2B;EAC3B,mCAAmC;EACnC,0CAA0C;EAC1C,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,oBAAoB;EACpB,4CAA4C;AAC9C;;AAEA;EACE,gCAAgC;EAChC,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,kCAAkC;EAClC,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,SAAO;AACT;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gCAAgC;EAChC,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,qCAAqC;EACrC,qBAAqB;EACrB,kBAAkB;EAClB,iCAAiC;EACjC,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sCAAsC;EACtC,6CAA6C;AAC/C;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;EAChC,qCAAqC;EACrC,gBAAgB;EAChB,gCAAgC;EAChC,WAAW;EACX,0CAA0C;AAC5C;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kCAAkC;EAClC,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,eAAe;AACf;EACE,kBAAkB;EAClB,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,kCAAkC;EAClC,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,qCAAqC;EACrC,sCAAsC;EACtC,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,kCAAkC;EAClC,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,SAAO;EACP,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,YAAY;EACZ,iBAAiB;EACjB,sBAAsB;EACtB,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE,mBAAmB;EACnB,oBAAoB;EACpB,0CAA0C;AAC5C;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,uCAAuC;EACvC,oCAAoC;EACpC,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,sBAAsB;EACtB,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,qDAAqD;EACrD,YAAY;EACZ,wBAAwB;EACxB,YAAY;EACZ,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,qDAAqD;EACrD,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,uBAAuB;AACzB;;AAEA;EACE,kCAAkC;EAClC,iBAAiB;EACjB,SAAS;EACT,kBAAkB;AACpB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,oBAAoB;EACpB,8CAA8C;EAC9C,oCAAoC;AACtC;;AAEA;EACE,kCAAkC;EAClC,gCAAgC;EAChC,uBAAuB;EACvB,YAAY;EACZ,qBAAqB;EACrB,eAAe;EACf,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,wCAAwC;EACxC,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,qBAAqB;EACrB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,+CAA+C;EAC/C,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,uCAAuC;EACvC,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB","sourcesContent":[".change-prompt-modal {\n  /* Glassmorphism effect */\n  background: rgba(255, 255, 255, 0.9);\n  backdrop-filter: blur(12px);\n  -webkit-backdrop-filter: blur(12px);\n  border: 1px solid rgba(255, 255, 255, 0.3);\n  border-radius: 1rem;\n  padding: 0;\n  max-width: 550px;\n  width: 90%;\n  max-height: 80vh;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);\n}\n\n.change-prompt-modal .modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1.5rem 2rem;\n  border-bottom: 1px solid var(--color-border);\n}\n\n.change-prompt-modal .modal-header h2 {\n  color: var(--color-text-primary);\n  margin: 0;\n  font-size: 1.5rem;\n}\n\n.change-prompt-modal .close-button {\n  background: none;\n  border: none;\n  font-size: 1.5rem;\n  cursor: pointer;\n  color: var(--color-text-secondary);\n  padding: 0;\n  line-height: 1;\n}\n\n.change-prompt-modal .close-button:hover {\n  color: var(--color-text-primary);\n}\n\n.change-prompt-modal .modal-body {\n  padding: 1.5rem 2rem;\n  overflow-y: auto;\n  flex: 1;\n}\n\n.change-prompt-modal .form-group {\n  margin-bottom: 1.5rem;\n}\n\n.change-prompt-modal .form-group label {\n  display: block;\n  font-weight: 500;\n  color: var(--color-text-primary);\n  margin-bottom: 0.5rem;\n  font-size: 0.95rem;\n}\n\n/* Searchable Dropdown */\n.change-prompt-modal .searchable-dropdown {\n  position: relative;\n  width: 100%;\n}\n\n.change-prompt-modal .prompt-search-input {\n  width: 100%;\n  padding: 0.75rem;\n  border: 1px solid var(--color-border);\n  border-radius: 0.5rem;\n  font-size: 0.95rem;\n  background: var(--color-input-bg);\n  color: var(--color-text-primary);\n  box-sizing: border-box;\n}\n\n.change-prompt-modal .prompt-search-input:focus {\n  outline: none;\n  border-color: var(--color-input-focus);\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n}\n\n.change-prompt-modal .prompt-search-input::placeholder {\n  color: var(--color-text-secondary);\n}\n\n.change-prompt-modal .prompt-dropdown-list {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  max-height: 200px;\n  overflow-y: auto;\n  background: var(--color-card-bg);\n  border: 1px solid var(--color-border);\n  border-top: none;\n  border-radius: 0 0 0.5rem 0.5rem;\n  z-index: 10;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n}\n\n.change-prompt-modal .dropdown-item {\n  padding: 0.75rem;\n  cursor: pointer;\n  color: var(--color-text-primary);\n  font-size: 0.9rem;\n  line-height: 1.4;\n  border-bottom: 1px solid var(--color-border);\n}\n\n.change-prompt-modal .dropdown-item:last-child {\n  border-bottom: none;\n}\n\n.change-prompt-modal .dropdown-item:hover {\n  background: rgba(59, 130, 246, 0.1);\n}\n\n.change-prompt-modal .dropdown-item.selected {\n  background: rgba(59, 130, 246, 0.15);\n  font-weight: 500;\n}\n\n.change-prompt-modal .dropdown-no-results {\n  padding: 0.75rem;\n  color: var(--color-text-secondary);\n  font-style: italic;\n  text-align: center;\n}\n\n/* AI Section */\n.change-prompt-modal .ai-section {\n  margin-top: 1.5rem;\n  padding-top: 1.5rem;\n  border-top: 1px solid var(--color-border);\n}\n\n.change-prompt-modal .ai-section-header {\n  color: var(--color-text-primary);\n  font-size: 1.1rem;\n  margin: 0 0 1rem 0;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.change-prompt-modal .ai-section-header::before {\n  content: '✨';\n}\n\n.change-prompt-modal .ai-loading {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  color: var(--color-text-secondary);\n  padding: 0.5rem 0;\n}\n\n.change-prompt-modal .spinner {\n  width: 1.25rem;\n  height: 1.25rem;\n  border: 2px solid var(--color-border);\n  border-top-color: var(--color-primary);\n  border-radius: 50%;\n  animation: spin 0.8s linear infinite;\n}\n\n@keyframes spin {\n  to { transform: rotate(360deg); }\n}\n\n.change-prompt-modal .ai-error {\n  color: var(--color-danger);\n  padding: 0.75rem;\n  background: rgba(255, 59, 48, 0.1);\n  border-radius: 0.5rem;\n  font-size: 0.9rem;\n}\n\n.change-prompt-modal .ai-no-suggestions {\n  color: var(--color-text-secondary);\n  font-style: italic;\n  padding: 0.75rem;\n}\n\n/* Suggestions List */\n.change-prompt-modal .suggestions-list {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.change-prompt-modal .suggestion-item {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.75rem;\n  padding: 0.5rem 0;\n  cursor: pointer;\n}\n\n.change-prompt-modal .suggestion-item:hover {\n  opacity: 0.8;\n}\n\n.change-prompt-modal .suggestion-item input[type=\"radio\"] {\n  margin-top: 0.25rem;\n  cursor: pointer;\n  accent-color: var(--color-primary);\n}\n\n.change-prompt-modal .suggestion-text {\n  flex: 1;\n  color: var(--color-text-primary);\n  font-size: 0.9rem;\n  line-height: 1.4;\n}\n\n.change-prompt-modal .best-match-badge {\n  background: var(--color-primary);\n  color: white;\n  font-size: 0.7rem;\n  padding: 0.2rem 0.5rem;\n  border-radius: 9999px;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n/* New Prompt Section */\n.change-prompt-modal .new-prompt-section {\n  margin-top: 1.25rem;\n  padding-top: 1.25rem;\n  border-top: 1px dashed var(--color-border);\n}\n\n.change-prompt-modal .new-prompt-header {\n  color: var(--color-text-primary);\n  font-size: 0.95rem;\n  margin: 0 0 0.75rem 0;\n  font-weight: 500;\n}\n\n.change-prompt-modal .new-suggestion {\n  border: 1px dashed var(--color-primary);\n  background: rgba(59, 130, 246, 0.05);\n  padding: 0.75rem;\n  border-radius: 0.5rem;\n}\n\n.change-prompt-modal .new-prompt-badge {\n  background: #10b981;\n  color: white;\n  font-size: 0.7rem;\n  padding: 0.2rem 0.5rem;\n  border-radius: 9999px;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n/* Generate Prompt Button */\n.change-prompt-modal .generate-prompt-action {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.change-prompt-modal .btn-generate-prompt {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  background: linear-gradient(135deg, #8b5cf6, #6366f1);\n  color: white;\n  padding: 0.75rem 1.25rem;\n  border: none;\n  border-radius: 0.5rem;\n  cursor: pointer;\n  font-size: 0.95rem;\n  font-weight: 500;\n  transition: all 0.2s;\n  width: 100%;\n}\n\n.change-prompt-modal .btn-generate-prompt:hover:not(:disabled) {\n  background: linear-gradient(135deg, #7c3aed, #4f46e5);\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(139, 92, 246, 0.3);\n}\n\n.change-prompt-modal .btn-generate-prompt:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.change-prompt-modal .btn-generate-prompt .spinner {\n  width: 1rem;\n  height: 1rem;\n  border: 2px solid rgba(255, 255, 255, 0.3);\n  border-top-color: white;\n}\n\n.change-prompt-modal .generate-prompt-hint {\n  color: var(--color-text-secondary);\n  font-size: 0.8rem;\n  margin: 0;\n  text-align: center;\n}\n\n/* Modal Actions */\n.change-prompt-modal .modal-actions {\n  display: flex;\n  gap: 1rem;\n  justify-content: flex-end;\n  padding: 1.5rem 2rem;\n  border-top: 1px solid rgba(255, 255, 255, 0.3);\n  background: rgba(255, 255, 255, 0.5);\n}\n\n.change-prompt-modal .btn-cancel {\n  background: var(--color-secondary);\n  color: var(--color-text-primary);\n  padding: 0.75rem 1.5rem;\n  border: none;\n  border-radius: 0.5rem;\n  cursor: pointer;\n  font-size: 1rem;\n  transition: all 0.2s;\n}\n\n.change-prompt-modal .btn-cancel:hover:not(:disabled) {\n  background: var(--color-secondary-hover);\n  transform: translateY(-2px);\n}\n\n.change-prompt-modal .btn-cancel:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.change-prompt-modal .btn-accept {\n  background: var(--color-primary);\n  color: white;\n  padding: 0.75rem 1.5rem;\n  border: none;\n  border-radius: 0.5rem;\n  cursor: pointer;\n  font-size: 1rem;\n  font-weight: 600;\n  transition: all 0.2s;\n}\n\n.change-prompt-modal .btn-accept:hover:not(:disabled) {\n  background: var(--color-primary-hover, #2563eb);\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);\n}\n\n.change-prompt-modal .btn-accept:disabled {\n  background: var(--color-text-secondary);\n  cursor: not-allowed;\n  transform: none;\n  box-shadow: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
